import React from 'react';
import { BreadcrumbItem } from 'react-bootstrap';
import { TbChevronRight } from 'react-icons/tb';
import PageMetaData from './PageMetaData';

const breadcrumbRenderers = {
  home: () => <BreadcrumbItem href="/homepage">Home</BreadcrumbItem>,
  link: ({ text, url }) => <BreadcrumbItem href={url}>{text}</BreadcrumbItem>,
  span: ({ text }) => <BreadcrumbItem active>{text}</BreadcrumbItem>,
};

function PageBreadcrumb({ items = [], pageTitle }) {
  return (
    <>
      <PageMetaData title={pageTitle} />
      <div className="page-title-head d-flex align-items-center">
        <div className="text-end">
          <div className="breadcrumb m-0 py-0 d-flex align-items-center gap-1">
            {items.map((item, index) => {
              const isLast = index === items.length - 1;
              const renderFn = breadcrumbRenderers[item.type];

              if (!renderFn) return null;

              return (
                <React.Fragment key={item.id}>
                  {renderFn(item)}
                  {!isLast && <TbChevronRight />}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default PageBreadcrumb;
